import type { RouteRecordRaw } from 'vue-router'

// 独立 H5 落地页（浏览器直达，不依赖主 App 运行时）
export const webRoutes: RouteRecordRaw[] = [
  {
    // 根路径 → 下载页
    path: '/',
    redirect: '/download',
  },
  {
    // 下载页
    path: '/download',
    name: 'web-download',
    component: () => import('@/pages/Web/Download/index.vue'),
    meta: { backMode: 'allow' },
  },
  {
    // 海外支付完成页
    path: '/overseas/payment/completed',
    name: 'web-overseas-payment-completed',
    component: () => import('@/pages/Web/OverSeas/Payment/index.vue'),
    meta: { backMode: 'allow' },
  },
]
